<template>
  <div class="default-card-layout" :class="{ 'disabled_card': item.disabled }" v-if="!item.deleted"
    style="cursor: pointer">
    <div class="default-card-content" @click="$emit('open', $event)">
      <div class="default-card-main">
        <div class="default-card-img bg editor_trigger" v-if="item.image"
          :style="{ backgroundImage: $filters.backgroundImage(item.image) }"></div>
        <div class="default-card-img bg editor_trigger" v-else></div>
        <div class="default-card-title"> {{ $dynamic(item, item.name, 'name') }}</div>
      </div>
      <div class="available out_stock" v-if="item.disabled"><span>{{ $static('category.available1', 'Не активно')
          }}</span></div>
      <div class="available in_stock" v-else><span>{{ $static('category.available2', 'Активно') }}</span></div>
      <div class="toggle-holder toggle-hidden">
        <div class="toggler r">
          <input type="checkbox" class="toggle-check" @click.stop v-model.boolean="item.disabled" :true-value="1"
            :false-value="0">
          <div class="knobs"></div>
          <div class="layer"></div>
        </div>
      </div>
      <div class="actions-box">
        <Popper arrow :content="$static('iconsbtn.up', 'Нагору')" hover placement="top" style="white-space: nowrap">
          <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger" @click.prevent.stop="$emit('up')">
            <span class="icon icon-up"></span>
          </button>
        </Popper>
        <Popper arrow :content="$static('iconsbtn.down', 'Вниз')" hover placement="top" style="white-space: nowrap">
          <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger" @click.prevent.stop="$emit('down')">
            <span class="icon icon-down"></span>
          </button>
        </Popper>
        <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
          style="white-space: nowrap">
          <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger">
            <span class="icon icon-edit"></span>
          </button>
        </Popper>
        <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
          style="white-space: nowrap">
          <a href="javascript:void(0)" class="btn-icon btn-rounded btn-icon-transparent btn-remove"
            @click.prevent.stop="$emit('remove', $event)">
            <span class="icon icon-trash"></span>
          </a>
        </Popper>

      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'

export default {
  name: 'CategoriesRow',
  props: ['item'],
  data() {
    return {
      load: false
    }
  },
  methods: {
    // makeCopy() {
    //   let copy = Object.assign({}, this.item, {disabled: true});
    //   delete copy['id'];
    //   delete copy['updated_at'];
    //   delete copy['created_at'];
    //
    //   api.post('/api/options', {list: [copy]}).then(() => {
    //     this.$emit('onCopy')
    //   })
    // },

  },
  watch: {
    'item.disabled'(val) {
      if (this.load) {
        return
      }
      this.load = true;
      api.put('/api/options', {
        id: this.item.id,
        disabled: val
      }).then(response => response.data).then(data => {
        this.load = false;
        this.item.disabled = data.disabled ? 1 : 0;
        this.item.updated_at = data.updated_at;
      })
    }
  }
}
</script>
